<template>
  <div
    class="generate-from-doc__wrapper"
    @click="importFileToGetQuiz()"
  >
    <aha-icon name="document-dark" class="mr-1"></aha-icon>
    <span>{{ $i18nPresenter.t('Generate from doc') }}</span>
  </div>
</template>

<script>
import { mapState, mapGetters, mapActions } from 'vuex'
import Utils from '@/util'
import { AI_GENERATE_QUIZ_FROM_DOC } from '@/constant/eventActions'
import { PRESENTATION_EDITOR } from '@/constant/eventCategories'

export default {
  computed: {
    ...mapGetters(['isDisableWhenNotOwner']),
    ...mapGetters('docToSlideGenerator', ['isDocToSlideGenerating', 'isDocToSlideImportModalVisible']),
    ...mapState({
      presentation: (state) => state.presentation,
      currentUser: (state) => state.currentUser,
      isDisableEditPresentation: (state) => state.isDisableEditPresentation,
    }),
  },
  methods: {
    ...mapActions('docToSlideGenerator', ['toggleDocToSlideImportModalAction']),
    importFileToGetQuiz() {
      if (this.isDisableEditPresentation || this.isDocToSlideGenerating) return
      this.toggleDocToSlideImportModalAction(true)
      this._trackOpenImportModal()
    },
    _trackOpenImportModal() {
      const eventAction = `${AI_GENERATE_QUIZ_FROM_DOC} > Open import modal`
      const trackData = {
        eventAction,
        eventCategory: PRESENTATION_EDITOR,
        presentationId: this.presentation.id,
        userId: this.currentUser.id,
      }
      Utils.trackGA4AndMixpanel(eventAction, trackData)
    },
  },
}
</script>

<style lang="scss" scoped>
.generate-from-doc__wrapper {
  @apply flex items-center cursor-pointer hover:text-primary-90 pr-3 text-sm;
  text-align: center;
  background-color: #fff;
  border-right: 1.5px solid #CECECE;
  &.disabled {
    @apply cursor-not-allowed;
    &:hover {
      color: unset;
    }
  }
}
</style>
